module.exports = __webpack_public_path__ + "static/media/introduction-recibase_03.949e52db.jpg";